import * as _ from "lodash";
import { useState } from "react";
import { useRouter } from "next/router";
import World from "../world";
import { MaybeAPIErr } from "../api";
import { ifBrowser } from "../utils";

type RegisterHook = {
    onChange: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    error: MaybeAPIErr;
    isPending: boolean;
}

function useRegister(world: World, onSuccess: () => void, discount?: string): RegisterHook {
    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<MaybeAPIErr>(null);
    const [isPending, setIsPending] = useState(false);

    const router = useRouter();

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        switch (e.currentTarget.name) {
        case "full_name":
            setFullName(e.currentTarget.value);
            break;
        case "email":
            setEmail(e.currentTarget.value);
            break;
        case "password":
            setPassword(e.currentTarget.value);
            break;
        }
    }

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setIsPending(true);
        setError(null);

        const err = await world.register({
            full_name: fullName,
            email: email,
            password: password,
            discount: discount,
        });

        setIsPending(false);

        if (err) {
            setError(err);
            return;
        }

        (window as any).gtag('event', 'conversion', {'send_to': 'AW-10896578733/la0BCPG-ksUDEK2x8sso'});

        (window as any).fbq("init", 1857456867824784, {
            em: world.host.email,
        });
        (window as any).fbq("track", "CompleteRegistration", {}, {
            eventID: `${world.host.id()}`,
        });

        onSuccess();
    }

    return {
        onChange,
        onSubmit,
        error,
        isPending,
    };
}

export default useRegister;
